import PropTypes from 'prop-types';
import {Box } from '@mui/material';


import Accountssidebar from 'src/components/accountsSidebar/risk-sdiebar';

import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';

export default function AccountsSideBarLayout({ children }) {
  const nav = useBoolean();
  console.log('-----------------------ajshdaksjhd')
  const renderNavVertical = <Accountssidebar openNav={nav.value} onCloseNav={nav.onFalse} />;
  const lgUp = useResponsive('up', 'lg');
  return (
    <>
        <Box
          sx={{
            minHeight: 1,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
          }}
        >
          {lgUp && renderNavVertical}
        <Box
          sx={{
            overflow: 'hidden',
          width:"100%",
          
          }}
        >
        {children}
        </Box>
        </Box>
    </>
  );
}

AccountsSideBarLayout.propTypes = {
  children: PropTypes.node,
};
